import { useLocation, useNavigate } from "react-router-dom"
import VerticalRule from "../components/VerticalRule"
import FlexColumn from "../layout/FlexColumn"
import PageContainer from "../layout/PageContainer"
import PortfolioCopy from "../layout/PortfolioCopy"
import PortfolioScroller from "../layout/PortfolioScroller"
import { useEffect, useState } from "react"
import { getSelected } from "../utils/nbutils"
import { svgImport } from "../images/SVGImageUtil"

const sectionID = 'design';

const markdown = `
jules byrne designs ***experiences***,
***applications***, and ***pitches*** for
hollywood and the web
`

const scrollerObject = {
    data : [
        { name : "ATEMP", 
            slug : "atemp",
            hideThumbText : true,
            thumbBackground : "svg/atemp.svg",
            headline : "ATEMP", h2 : "Academy of Transgender Entertainment and Media Professionals",
            copy : { 
                text : `ATEMP is a group formed by a coalition of high-profile
                trans entertainment professionals seeking greater representation in Hollywood. 
                ` }
        },
        { name : "Strike Banners", 
            slug : "strban",
            hideThumbText : true,
            thumbBackground : "svg/strikebanners.svg",
            headline : "Strike Banners", h2 : "Equity & Inclusion Banners for the Writers Strike",
            copy : { 
                text : `the 2023 writer's strike mobilized the sum-total of WGA and SAG-AFTRA's
                memberships to protest, strike, and march at various entities in Hollywood.
                This is a collection of social media banners designed by Jules Byrne that were
                circulated widely throughout Hollywood.
                ` }
        },
        { name : "créme", 
            slug : "creme",
            hideThumbText : true,
            thumbBackground : "svg/creme.svg",
            headline : "CRÉME", h2 : "a crm for everything",
            copy : { 
                text : `créme is a concept cms designed for rapid no-code
                configuration, flexible contexts, and advanced project,
                client, and contact management. the goal of créme is to
                reimagine what a cms can be, and how it can work for
                vertically integrated, cross-discipline teams. built in react,
                node.js, and mongodb.` }
        },
        { name : "OneResume", slug : "or", headline : "OneResume*",
            h2: "one internet. one resume.",
            hideThumbText : true,
            thumbBackground : "svg/oneresume.svg",
            copy : { text : `OneResume* is a reimaginging of the way resumes can be
                handled online. In our present world where there are a million job
                sites and a million resume importers that break your resume, why
                not create a standard for the web? OneResume* is that standard,
                wrapped up in a suite of tools to help you design and share your
                experience, and never have to retype anything you don't want to ever
                again. OneResume, and ORML, OrMark, and the OneExperience suite
                are the last resume builder you'll ever need.` }
         },
        { name : "scripty", slug : "scripty",
            hideThumbText : true,
            thumbBackground : "svg/scripty.svg",
            headline : "scripty", h2: "end-to-end tv and film production",
            copy : { text : `while there have been entertainment industry crms in the
                past, there has yet to be a unifying application designed to unite
                every discipline from writing, casting, and hiring, to post, continuity,
                and directing` }
         },
        { name : "RealJobs", slug : "realjobs",
            hideThumbText : true,
            thumbBackground : "svg/realjobs.svg",
            headline : "RealJobs", h2: "Verified Direct Jobs. No Recruiters. No AI.",
            copy : { text : `In 2024, there has been a massive proliferation of
                scam job listings introduced to the job market. Furthermore, 
                a lack of regulation allows large corporate recruiters to blast
                LinkedIn, Indeed, and ZipRecruiter with dozens if not hundreds of
                bogus job listings. Our answer? RealJobs. A stripped down job-search 
                platform that pairs with OneResume to allow switch searching and matching
                to jobs based on skills and experience, where every posting has been 
                verified by two real human beings talking on the phone. Yeah. Crazy,
                right? RealJobs - because everyone deserves peace of mind in 
                their job search.` }
         },
        { name : "BUDGE", slug : "budge",
            hideThumbText : true,
            thumbBackground : "svg/budge.svg",
            headline : "BUDGE", h2 : "Stupid Simple Budgets.",
            copy : { text : `BUDGE is a friendly budget assistant app that starts out simple,
                but has depth and complexity beneath the surface. Budge will guide you 
                through setting up your budget, either manually, or programatically, and
                make sure you're hitting budgetary goals - whether you're trying to get out
                of debt, buy a new house, or anything in between.
            ` }
         },
        { name : "talkingtrees", slug : "ttrees",
            hideThumbText : true,
            thumbBackground : "svg/talkingtrees.svg",
            headline : "talkingtrees", h2 : "pick up the axe. the trees are talking.",
            copy : { text : `talkingtrees is a dynamic object-based text-response-story engine,
                designed to build text-adventures, or power relationships, and dynamic story-telling
                in graphical games across all genres. currently talkingtrees is only implemented 
                in javascript, but support for other languages and platforms is forthcoming. 
            `}
         },
        { name : "QuikSite", slug : "qs",
            hideThumbText : true,
            thumbBackground : "svg/quiksite.svg",
            headline : "QuikSite", h2 : "Gather Assets. Write JSON. Export Website.",
            copy : { text : `QuikSite is a lightweight json driven wrapper for react and
                react-router. It's conceived and designed to output websites at a
                rapid clip, designed after Jules Byrne's legacy flash EPKKit that powered
                dozens of brand sites and EPKs in the early aughts.
            ` }
         },
         { name : "SnapPrep", slug : "sp",
            hideThumbText : true,
            thumbBackground : "svg/snapprep.svg",
            headline : "SnapPrep", h2 : "I'll expedite that for you.",
            copy : { text : `SnapPrep is a highly customizable kitchen time-management 
                optimization platform. Designed to track, manage, and streamline kitchen
                workflows, SnapPrep aims to assist restaurants in balancing their 
                delivery and in house businesses in order to reduce wait times, and
                alleviate stress on wait and kitchen staff.
            ` }
         },
         { name : "AdForceOne", slug : "afo",
            hideThumbText : true,
            thumbBackground : "svg/adforceone.svg",
            headline : "AdForceOne", h2 : "OMS, beautified.",
            copy : { text : `AdForceOne was designed to replace older OMS suites in use
                by ZiffDavis Inc. AFO was a massive project with tight Salesforce and DFP
                integrations. 
            ` }
         },
         { name : "ADML", slug : "adml",
            hideThumbText : true,
            thumbBackground : "svg/adml.svg",
            headline : "ADML", h2 : "Dynamic ad building and serving",
            copy : { text : `Jules Byrne was awarded a patent for ADML, the ADvertising
                Markup Language. ADML was designed to handle the nascent needs of the
                dynamic and richly-interactive video ad market in the 2010's. The system,
                in connection with its primary renderers, SUGR and Xumo, served billions
                of impressions of highly-trackable, highly-convertable media in the era
                before ubiquitous social-media marketing, and integrated shopping experiences
                in Instagram and Facebook. Many techniques and ad-formats that now permeate 
                the web writ-large were pioneered with ADML inside of Xumo and SUGR.
            ` }
         },
    ],
    selected : "",
    section : sectionID,
}

const mkSlugTree = (arr) => {
    const nst = {};
    for ( let i = 0; i < arr.length; i ++ ) {
        nst[arr[i].slug] = arr[i];
    }
    return nst;
}

const DesignPage = () => {

    const slugTree = mkSlugTree(scrollerObject.data);
    const navigate = useNavigate();

    const loc = useLocation();
    const initPath = getSelected(loc.pathname);

    const [selected, setSelected] = useState(initPath);

    //console.log("initial path", loc.pathname, getSelected(loc.pathname));

    scrollerObject.selected = getSelected(loc.pathname);

    const ue = useEffect(() => {
        const nselected = getSelected(loc.pathname);
        setSelected(nselected);
        if ( initPath.toLowerCase() === sectionID || initPath === "" ) {
            navigate(`/${sectionID}/${scrollerObject.data[0].slug}`);
        }
        scrollerObject.selected = nselected;
    }, [loc, initPath, navigate])

    return (
        <PageContainer>
            <FlexColumn key={"column_left"} widthClass={"w30"}>
                <PortfolioScroller
                    thumbScroller={scrollerObject} 
                    textArea={{ 
                        text : markdown, 
                        styleRules : { mod : sectionID } }} />
            </FlexColumn>
            <FlexColumn key={"vertical_rule"} widthClass={"vertical_rule"}>
                <VerticalRule />
            </FlexColumn>
            <FlexColumn key={"colum_right"} widthClass={"rightcol"}>
                <PortfolioCopy {...slugTree[selected]} />
            </FlexColumn>
        </PageContainer>
    )
}

export default DesignPage;